import React, { memo, useState } from "react";
import {
  SportsMobFilterBarIconMark,
  SportsMobFilterBarIconWrapper,
  SportsMobFilterBarWrapper,
} from "./style";
import { ReactComponent as FilterIcon } from "@/assets/img/icons/icon-filter-option.svg";
import { Drawer } from "antd";
import KTFilterMobBarButton from "../../../../components/filter/filter-mob-bar-button";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getChangeSportsSortModeAction } from "../../store/actionCreators";
import KTSportsFilterContent from "../sports-mob-filter-content";
import { sportsAllEventsSortModes } from "../../local-data";

const KTSportsMobFilterBar = memo(() => {
  const [filterViewOpen, setFilterViewOpen] = useState(false);

  const dispatch = useDispatch();

  const { sortMode, intervalType = "0" } = useSelector(
    (state) => ({
      sortMode: state.getIn(["sports", "sortMode"]),
      intervalType: state.getIn(["sports", "intervalType"]),
    }),
    shallowEqual
  );

  function onChangeSortModeItem(mode) {
    dispatch(getChangeSportsSortModeAction(mode));
  }

  const isDefaultFilter = intervalType === "0";

  return (
    <SportsMobFilterBarWrapper>
      <KTFilterMobBarButton
        title={sortMode.title}
        switchItems={sportsAllEventsSortModes}
        onChangeSwitchItem={onChangeSortModeItem}
      />
      <SportsMobFilterBarIconWrapper>
        <FilterIcon
          className="optionButton"
          onClick={() => setFilterViewOpen(true)}
        />
        {isDefaultFilter ? null : <SportsMobFilterBarIconMark />}
      </SportsMobFilterBarIconWrapper>

      <Drawer
        closeIcon={null}
        placement="bottom"
        height={`100%`}
        open={filterViewOpen}
        onClose={() => setFilterViewOpen(false)}
        style={{
          borderRadius: "20rem 20rem 0 0",
          background: "#FFF",
        }}
        bodyStyle={{ padding: "0" }}
      >
        <KTSportsFilterContent onClose={() => setFilterViewOpen(false)} />
      </Drawer>
    </SportsMobFilterBarWrapper>
  );
});

export default KTSportsMobFilterBar;
